module.exports = __webpack_public_path__ + "img/40-WHEEL.6fdd6e3b.png";